import React from 'react';
import { Icon } from '../icon/Icon.jsx';

/* Every lifecycle state, with a fixed appearance so the state is recognised by
   SHAPE before it is read. LIVE is the only one with a full border — it should
   be the pill your eye lands on first in a list. */

const STATES = {
  DRAFT:      { bg: 'transparent', fg: 'var(--text-secondary)', bd: 'var(--border-default)' },
  VALIDATING: { bg: 'transparent', fg: 'var(--accent)', bd: 'var(--accent)', icon: 'circle-dashed' },
  VALIDATED:  { bg: 'var(--accent-subtle)', fg: 'var(--accent)', bd: 'transparent' },
  REJECTED:   { bg: 'transparent', fg: 'var(--loss)', bd: 'var(--loss)' },
  PAPER:      { bg: 'var(--paper-tint)', fg: 'var(--paper)', bd: 'transparent', icon: 'circle-dashed' },
  LIVE:       { bg: 'var(--live-tint)', fg: 'var(--live)', bd: 'var(--live)', icon: 'circle', filled: true },
  SUSPENDED:  { bg: 'rgba(158,58,58,.15)', fg: 'var(--loss)', bd: 'transparent', icon: 'triangle-alert' },
  RETIRED:    { bg: 'transparent', fg: 'var(--text-tertiary)', bd: 'var(--border-subtle)' },
  STOPPED:    { bg: 'transparent', fg: 'var(--text-tertiary)', bd: 'var(--border-subtle)', icon: 'circle' },
};

export function StatePill({ state = 'DRAFT', label, style }) {
  const s = STATES[state] || STATES.DRAFT;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 'var(--space-4)', padding: '2px 8px',
      background: s.bg, color: s.fg, border: '1px solid ' + s.bd, borderRadius: 'var(--radius-pill)',
      fontSize: 'var(--label-size)', lineHeight: 'var(--label-line)', fontWeight: 'var(--label-weight)',
      letterSpacing: 'var(--label-tracking)', textTransform: 'uppercase', whiteSpace: 'nowrap', ...style,
    }}>
      {s.icon ? <Icon name={s.icon} size={11} filled={!!s.filled} /> : null}
      {label || state}
    </span>
  );
}
